import { render, staticRenderFns } from "./SearchChannelPermissions.vue?vue&type=template&id=7a87fd6c"
import script from "./SearchChannelPermissions.vue?vue&type=script&lang=js"
export * from "./SearchChannelPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports